export default __webpack_public_path__ + "static/media/100ELS.59c1e19e.webp";